/* AURÉ — "Find your ritual" quiz. Vanilla, zero dependencies.
   Deterministic scoring: constant 12-point total, unique leader >= 45%
   wins the SKU (+ Full Ritual upsell); any tie or 3+-SKU spread with no
   leader resolves to The Full Ritual. No randomness, no network.

   Shopify port note: the original IIFE body is UNCHANGED — it is only
   wrapped in initAureQuiz(), which runs on DOMContentLoaded and again on
   the theme editor's `shopify:section:load` (the editor re-renders section
   DOM without a page load). Double-init is guarded via a data-initialized
   attribute on #quiz; #quiz is re-queried on every call. */
function initAureQuiz() {
  'use strict';

  var quiz = document.getElementById('quiz');
  if (!quiz) return;
  if (quiz.hasAttribute('data-initialized')) return;
  quiz.setAttribute('data-initialized', 'true');

  var SKUS = ['halo', 'clear', 'ease', 'dusk'];
  var THRESHOLD = 0.45;

  var steps = Array.prototype.slice.call(quiz.querySelectorAll('.q-step'));
  var dots = Array.prototype.slice.call(quiz.querySelectorAll('.q-dot'));
  var progressNum = quiz.querySelector('[data-q-progress]');
  var backBtn = quiz.querySelector('.q-back');
  var body = quiz.querySelector('.q-body');
  var resultRegion = quiz.querySelector('.q-result');
  var foot = quiz.querySelector('.q-result-foot');

  var current = 0;
  var answers = steps.map(function () { return null; });
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* "halo:2 clear:1" -> { halo: 2, clear: 1 } */
  function parseWeights(str) {
    var out = {};
    String(str || '').trim().split(/\s+/).forEach(function (pair) {
      var kv = pair.split(':');
      if (kv.length === 2 && SKUS.indexOf(kv[0]) !== -1) {
        out[kv[0]] = parseInt(kv[1], 10) || 0;
      }
    });
    return out;
  }

  function animateIn(el) {
    el.classList.remove('is-in');
    if (!reduceMotion.matches) { void el.offsetWidth; } /* restart animation */
    el.classList.add('is-in');
  }

  function show(index, moveFocus) {
    current = index;
    steps.forEach(function (step, i) {
      if (i === index) { step.hidden = false; animateIn(step); }
      else { step.hidden = true; }
    });
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-done', i < index);
      dot.classList.toggle('is-current', i === index);
    });
    progressNum.textContent = (index + 1) + ' of ' + steps.length;
    backBtn.hidden = index === 0;
    if (moveFocus) {
      var legend = steps[index].querySelector('.q-question');
      if (legend) legend.focus();
    }
  }

  function choose(btn) {
    var step = btn.closest('.q-step');
    var index = steps.indexOf(step);
    if (index === -1) return;

    answers[index] = {
      weights: parseWeights(btn.getAttribute('data-q-weights')),
      echo: btn.getAttribute('data-q-echo') || ''
    };
    Array.prototype.forEach.call(step.querySelectorAll('.q-option'), function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });

    if (index < steps.length - 1) { show(index + 1, true); }
    else { finish(); }
  }

  /* Deterministic. Precedence:
     1) exactly one top-scoring SKU AND top/total >= 45%  -> that SKU
     2) everything else (tie, or 3+ SKU spread w/o leader) -> full ritual */
  function computeResult() {
    var totals = { halo: 0, clear: 0, ease: 0, dusk: 0 };
    answers.forEach(function (a) {
      if (!a) return;
      SKUS.forEach(function (k) { totals[k] += a.weights[k] || 0; });
    });
    var total = 0, max = 0;
    SKUS.forEach(function (k) { total += totals[k]; if (totals[k] > max) max = totals[k]; });
    var leaders = SKUS.filter(function (k) { return totals[k] === max; });
    if (total > 0 && leaders.length === 1 && max / total >= THRESHOLD) {
      return leaders[0];
    }
    return 'full';
  }

  /* Echo of the earliest answer that contributed most to the winner. */
  function strongestEcho(sku) {
    var best = '', bestWeight = 0;
    answers.forEach(function (a) {
      if (!a) return;
      var w = a.weights[sku] || 0;
      if (w > bestWeight) { bestWeight = w; best = a.echo; }
    });
    return best;
  }

  function finish() {
    var sku = computeResult();
    var tpl = document.getElementById('q-tpl-' + sku);
    if (!tpl) return;

    body.hidden = true;
    dots.forEach(function (dot) {
      dot.classList.add('is-done');
      dot.classList.remove('is-current');
    });
    progressNum.textContent = 'complete';

    var card = tpl.content.cloneNode(true).firstElementChild;
    if (sku !== 'full') {
      var echoText = strongestEcho(sku);
      var slot = card.querySelector('[data-q-echo-slot]');
      if (echoText && slot) {
        slot.querySelector('[data-q-echo-text]').textContent = echoText;
        slot.hidden = false;
      }
    }
    resultRegion.innerHTML = '';
    resultRegion.appendChild(card); /* instant — no fake loading */
    animateIn(card);
    foot.hidden = false;

    var headline = card.querySelector('.q-result-headline');
    if (headline) headline.focus();
  }

  function restart() {
    answers = steps.map(function () { return null; });
    Array.prototype.forEach.call(quiz.querySelectorAll('.q-option'), function (b) {
      b.setAttribute('aria-pressed', 'false');
    });
    resultRegion.innerHTML = '';
    foot.hidden = true;
    body.hidden = false;
    show(0, true);
  }

  /* Clicks — real <button>s, so Enter/Space work natively. */
  quiz.addEventListener('click', function (e) {
    var opt = e.target.closest('.q-option');
    if (opt) { choose(opt); return; }

    if (e.target.closest('.q-back')) {
      if (current > 0) show(current - 1, true);
      return;
    }
    if (e.target.closest('.q-restart')) { restart(); return; }

    var cta = e.target.closest('.q-cta');
    if (cta) {
      /* Integration point: site-wide toast (aure.js) listens for this. */
      quiz.dispatchEvent(new CustomEvent('aure:add-to-ritual', {
        bubbles: true,
        detail: { sku: cta.getAttribute('data-q-sku') }
      }));
      /* Inline fallback confirmation (announced via role=status). */
      var card = cta.closest('.q-card');
      if (card && !card.querySelector('.q-cta-done')) {
        var done = document.createElement('p');
        done.className = 'q-cta-done';
        done.setAttribute('role', 'status');
        done.textContent = cta.getAttribute('data-q-confirm') || 'Added to your ritual.';
        cta.insertAdjacentElement('afterend', done);
      }
    }
  });

  /* "Save my ritual" — validate inline first. When the form is a real
     Shopify {% form 'customer' %} (data-real-form) a valid email submits
     natively — no fake confirmation. Forms without data-real-form (none
     ship) keep the inline demo confirmation as a guarded fallback. */
  quiz.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('q-save')) return;

    var input = form.querySelector('.q-save-input');
    var err = form.querySelector('.q-save-err');
    var value = (input.value || '').trim();

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      e.preventDefault();
      err.textContent = 'That address doesn’t look quite right — mind checking it?';
      err.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return;
    }

    input.removeAttribute('aria-invalid');
    err.hidden = true;

    if (form.hasAttribute('data-real-form')) return; /* real customer form — let it POST natively */

    /* No real form wired — inline demo confirmation only. */
    e.preventDefault();
    var done = document.createElement('p');
    done.className = 'q-save-done';
    done.setAttribute('role', 'status');
    done.setAttribute('tabindex', '-1');
    done.textContent = 'Saved — this ritual will be waiting at ' + value + '.';
    form.replaceWith(done);
    done.focus();
  });

  show(0, false); /* normalize initial state; no focus steal on load */
}

document.addEventListener('DOMContentLoaded', initAureQuiz);
if (document.readyState !== 'loading') { initAureQuiz(); }
/* Theme editor re-renders section DOM without a page load — re-init. */
document.addEventListener('shopify:section:load', function () { initAureQuiz(); });
